import PageBox from "PFComponents/box/page_box";
import DataTable from "PFComponents/data_table/data_table";
import Toggle from "PFComponents/toggle/toggle";
import SaasAdminHeader from "PFModules/saas_admin/shared/saas_admin_header";
import PropTypes from "prop-types";
import React from "react";

import css from "./activity_templates_list_page.less";

const ActivityTemplatesListPage = ({ activityTemplates, toggleActivityTemplate, accountName }) => {
  const cellRenderer = (attribute, className = "") =>
    attribute ? <span className={className}>{attribute}</span> : null;

  const renderActions = (data) => (
    <Toggle inline checked={data.active} onChange={() => toggleActivityTemplate(data.id, !data.active)} />
  );

  return (
    <div className={css.activityTemplatesListPage}>
      <SaasAdminHeader title="Activity Templates" subTitle={`(for ${accountName})`} fixedWidth={false} />
      <PageBox
        style={{
          marginTop: "2rem",
          marginBottom: "2rem",
          paddingTop: "0.8rem"
        }}
      >
        <DataTable
          columns={[
            {
              headerName: "Key",
              renderCell: (data) => cellRenderer(data.key)
            },
            {
              headerName: "Name",
              renderCell: (data) => cellRenderer(data.name)
            },
            {
              headerName: "Description",
              renderCell: (data) => cellRenderer(data.description)
            },
            {
              headerName: "Actions",
              renderCell: (data) => renderActions(data)
            }
          ]}
          data={activityTemplates}
        />
      </PageBox>
    </div>
  );
};

ActivityTemplatesListPage.propTypes = {
  activityTemplates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      key: PropTypes.string,
      active: PropTypes.bool
    })
  ),
  toggleActivityTemplate: PropTypes.func,
  accountName: PropTypes.string
};

export default ActivityTemplatesListPage;
